module.exports = __webpack_public_path__ + "static/img/6.b3af7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/6.png
// module id = zpvb
// module chunks = 1